import { User } from '../../core/declarations/user.interface';
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { getCurrentUser } from '../../core/states/user-state/user.selectors';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReservationsEnabledGuard {
  constructor(private userStore: Store<User>) {}

  canActivateChild(
    _: ActivatedRouteSnapshot,
    __: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.userStore.select(getCurrentUser).pipe(
      filter(x => x !== null),
      map(user => user as User),
      map(user => !user.friend),
      first()
    );
  }
}
